import React from 'react';
import Header from './Header';
import Footer from './Footer';
import WhatsAppButton from './WhatsAppButton';
import BookingWidget from './BookingWidget';

// Page layout with a solid header background (used on inner pages that
// don't have a dark hero behind the transparent header).
const Layout = ({ children, solidHeader = true, booking = {}, hideBooking = false, bookingTop = true }) => {
  const widget = (
    <section className={bookingTop ? 'pt-24 pb-10 bg-[color:var(--brand-dark)]' : 'py-14 bg-[color:var(--brand-dark)]'} data-testid="layout-booking">
      <div className="max-w-3xl mx-auto px-4 sm:px-6"><BookingWidget defaultFrom={booking.from} defaultTo={booking.to} source={booking.src} /></div>
    </section>
  );
  return (
    <>
      <Header forceSolid={solidHeader} />
      {!hideBooking && bookingTop && widget}
      <main className={solidHeader && !bookingTop ? 'pt-24' : ''}>{children}</main>
      {!hideBooking && !bookingTop && widget}
      <Footer />
      <WhatsAppButton />
    </>
  );
};

export default Layout;
